// Url
export const url = {
    google_map_api: 'https://maps.googleapis.com/maps/api/geocode/json',
};
// ユーザーのアクティブ状態
export const activeStatus = {
    activity: 0,
    suspension: 1,
};
// 通知先
export const noticeTarget = {
    all: 0,
    clinic: 1,
    appUser: 2,
};
// ユーザータイプ
export const userType = {
    none: true,
    adminUser: true,
    appUser: true,
    clinicUser: true,
};
// クリニックタイプ
export const clinicUserType = {
    normal: 'normal',
    vip: 'vip',
};
// ページング
export const pagination = {
    limit: 20,
};
// 運営への支払い方法
export const billingPlanPaymentMethodType = {
    creditCard: 0,
    manualBank: 1,
};
// プラン契約のユーザー操作
export const billingUserOperationType = {
    newRegister: 0,
    change: 1,
    cancel: 2,
};
// 料金プラン
export const billingPlanType = {
    free: 0,
    standard: 1,
    performanceReward: 2,
    professional: 3,
};
// 成果報酬請求種別
export const employmentType = {
    partTimeOneDay: 0,
    partTimeShort: 1,
    fullTime: 2,
};
// 給与支払い方法(paymentList)
export const paymentType = {
    paymentCache: 0,
    paymentBankTransfer: 1,
};
// 送信ファイルサイズ制限
export const maxImageSize = 5 * 1024 * 1024;
